import { render } from "./MorningCall.vue?vue&type=template&id=4c63138f"
import script from "./MorningCall.vue?vue&type=script&lang=js"
export * from "./MorningCall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__